import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import addEditCopyClaims from '../components/addEditCopyClaims.vue';

var CopyClaimsPage = function (_super) {
  __extends(CopyClaimsPage, _super);

  function CopyClaimsPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  CopyClaimsPage = __decorate([Component({
    components: {
      addEditCopyClaims: addEditCopyClaims
    }
  })], CopyClaimsPage);
  return CopyClaimsPage;
}(Vue);

export default CopyClaimsPage;